import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    "model-value": _ctx.modelValue,
    label: "Client",
    options: _ctx.clients,
    "option-label": _ctx.optionLabel,
    "option-value": "id",
    "map-options": !_ctx.object,
    "emit-value": !_ctx.object,
    loading: _ctx.isLoading,
    "input-debounce": "1000",
    "use-input": "",
    clearable: "",
    "clear-icon": "fa fa-times"
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onFilter: _ctx.filter
  }), {
    prepend: _withCtx(() => [
      _createVNode(_component_q_icon, { name: "fa fa-search" })
    ]),
    _: 1
  }, 16, ["model-value", "options", "option-label", "map-options", "emit-value", "loading", "onFilter"]))
}